import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from 'constants/common';
import { PacksService } from 'services/packs';
import { type SessionPack } from 'types/packs';

export const useFetchSessionPacks = (specialityId: string): UseQueryResult<SessionPack[]> =>
  useQuery({
    queryKey: [QUERY_KEYS.FETCH_SESSION_PACKS],
    queryFn: async () => PacksService.getSessionPacks(specialityId),
    select: response => response.data,
    enabled: !!specialityId,
  });
